import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4653c793"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-form" }
const _hoisted_2 = { action: "" }
const _hoisted_3 = { class: "error-message" }

import Loading from 'vue-loading-overlay';
import FormButtons from '../FormButtons.vue';
import InputField from '@/components/InputField.vue';
import { ref } from 'vue';
import { UserData, FormItem } from '@/models/FormModels';
import useVuelidate from '@vuelidate/core';
import { email, helpers, required } from '@vuelidate/validators';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserForm',
  emits: ["onSend", "onPrevClick"],
  setup(__props, { emit }: { emit: ({
  (e: 'onSend', data: UserData): void;
  (e: 'onPrevClick',): void;
}), expose: any, slots: any, attrs: any }) {



const loading = ref<boolean>(false);

const userData = ref<UserData>(new UserData('', '', '', ''));

const formItems: FormItem[] = [
  new FormItem('firstname', 'Vorname*', undefined, 'text', '', undefined),
  new FormItem('lastname', 'Nachname*', undefined, 'text', '', undefined),
  new FormItem('email', 'E-Mail*', undefined, 'text', '', undefined),
  new FormItem('phone', 'Telefon*', undefined, 'text', '', undefined),
  new FormItem('information', undefined, undefined, 'textarea', 'weitere Informationen ...', undefined)
];

const phoneNumber = (phoneNumber: string) => (/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/.test(phoneNumber));

const validationRules = {
  firstname: { required: helpers.withMessage('Vorname eingeben', required) },
  lastname: { required: helpers.withMessage('Nachname eingeben', required) },
  email: {
    required: helpers.withMessage('E-Mail eingeben', required),
    email: helpers.withMessage('Keine gültige E-Mail', email)
  },
  phone: {
    required: helpers.withMessage('Telefonnummer eingeben', required),
    phoneNumber: helpers.withMessage('Keine gültige Telefonnummer', phoneNumber),
  },
  information: {}
}

const v$ = useVuelidate(validationRules, userData);

const validated = ref(false);
const send = async () => {
  validated.value = true;
  const isFormValid = await v$.value.$validate();
  if (isFormValid) {
    loading.value = true;
    emit('onSend', userData.value);
  }
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(formItems, (item, index) => {
        return _createElementVNode("div", { key: index }, [
          _createVNode(InputField, {
            class: _normalizeClass((_unref(v$)[item.selectedKey].$invalid || _unref(v$)[item.selectedKey].$pending) && validated.value ? 'invalid' : ''),
            type: item.type,
            label: item.label,
            selected: _unref(v$)[item.selectedKey].$model,
            "onUpdate:selected": ($event: any) => ((_unref(v$)[item.selectedKey].$model) = $event),
            options: item.options,
            optionLabel: item.optionLabel,
            placeholder: item.placeholder,
            id: item.selectedKey
          }, {
            errorMessage: _withCtx(() => [
              _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(v$)[item.selectedKey]?.$silentErrors?.length > 0 ?
                _unref(v$)[item.selectedKey].$silentErrors[0].$message : 'no'), 1)
            ]),
            _: 2
          }, 1032, ["class", "type", "label", "selected", "onUpdate:selected", "options", "optionLabel", "placeholder", "id"])
        ])
      }), 64))
    ]),
    _createVNode(FormButtons, {
      previous: true,
      send: true,
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (emit('onPrevClick'))),
      onClickSend: _cache[1] || (_cache[1] = ($event: any) => (send())),
      class: _normalizeClass('buttons' + (loading.value === true ? ' hide' : ''))
    }, null, 8, ["class"]),
    _createVNode(_unref(Loading), {
      active: loading.value,
      "is-full-page": false,
      color: "var(--orange)"
    }, null, 8, ["active"])
  ]))
}
}

})